type EnglishSourceTheme = "law" | "corporate" | "notary" | "naati";

const ENGLISH_SOURCES: Record<EnglishSourceTheme, Array<{ label: string; description: string; href: string }>> = {
  law: [
    { label: "Lawyers Council of Thailand", description: "Professional rules, lawyer information and official announcements.", href: "https://www.lawyerscouncil.or.th/" },
    { label: "Court of Justice", description: "Court locations, public court information and official judicial services.", href: "https://www.coj.go.th/" },
    { label: "Legal Execution Department", description: "Official guidance on enforcement, seizure, attachment and public auctions.", href: "https://www.led.go.th/" },
    { label: "Department of Business Development", description: "Company registration records, filings and corporate changes.", href: "https://www.dbd.go.th/" },
  ],
  corporate: [
    { label: "Department of Business Development", description: "Company registration, corporate filings and registered-office requirements.", href: "https://www.dbd.go.th/" },
    { label: "Revenue Department", description: "Tax registration, VAT obligations, filing guidance and official announcements.", href: "https://www.rd.go.th/" },
  ],
  notary: [
    { label: "Lawyers Council of Thailand", description: "Information about Thai lawyers and Notarial Services Attorney requirements.", href: "https://www.lawyerscouncil.or.th/" },
    { label: "Department of Consular Affairs", description: "Current legalisation procedures for documents issued in or used in Thailand.", href: "https://consular.mfa.go.th/" },
  ],
  naati: [
    { label: "NAATI", description: "Credential types, practitioner directory and official certification information.", href: "https://www.naati.com.au/" },
    { label: "Australian Department of Home Affairs", description: "Current document and translation requirements for Australian immigration applications.", href: "https://immi.homeaffairs.gov.au/" },
  ],
};

export function OfficialSourcesEn({ theme }: { theme: EnglishSourceTheme }) {
  return (
    <section aria-labelledby={`official-sources-en-${theme}`} className="not-prose mt-10 border-t border-border pt-8">
      <h2 id={`official-sources-en-${theme}`} className="text-xl font-semibold text-foreground">Official sources to check before filing</h2>
      <p className="mt-2 text-sm leading-relaxed text-muted-foreground">Requirements depend on the document, transaction and receiving authority. Confirm the current rules with the responsible authority before signing, filing or paying a government fee.</p>
      <ul className="mt-5 grid gap-4 md:grid-cols-2">
        {ENGLISH_SOURCES[theme].map((source) => (
          <li key={source.href} className="rounded-md border border-border p-4">
            <a href={source.href} target="_blank" rel="noopener noreferrer" className="font-semibold text-primary hover:underline">{source.label} <span aria-hidden="true">↗</span></a>
            <p className="mt-1 text-sm leading-relaxed text-muted-foreground">{source.description}</p>
          </li>
        ))}
      </ul>
    </section>
  );
}